const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
const AUTH_SCOPE = process.env.REACT_APP_AUTH_SCOPE;
const webBaseURL = process.env.REACT_APP_WEB_BASE_URL;
export const msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID ?? '',
        authority: 'https://login.microsoftonline.com/common',
        //redirectUri: '/login',
        //redirectUri: 'http://localhost:3000/login',
        redirectUri: `${webBaseURL}/login`,
        postLogoutRedirectUri: '/'
    },
    system: {
        allowNativeBroker: false
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    }
};
export const loginRequest = {
    scopes: [AUTH_SCOPE ?? '']
};
